/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateWorkspaceInput = {
    name: string;
    clientMutationId?: string | null | undefined;
};
export type createWorkspaceModalCreateWorkspaceMutationVariables = {
    input: CreateWorkspaceInput;
};
export type createWorkspaceModalCreateWorkspaceMutationResponse = {
    readonly createWorkspace: {
        readonly workspace: {
            readonly id: string;
            readonly name: string;
            readonly modified: Date;
        };
    } | null;
};
export type createWorkspaceModalCreateWorkspaceMutation = {
    readonly response: createWorkspaceModalCreateWorkspaceMutationResponse;
    readonly variables: createWorkspaceModalCreateWorkspaceMutationVariables;
};



/*
mutation createWorkspaceModalCreateWorkspaceMutation(
  $input: CreateWorkspaceInput!
) {
  createWorkspace(input: $input) {
    workspace {
      id
      name
      modified
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateWorkspacePayload",
    "kind": "LinkedField",
    "name": "createWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modified",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createWorkspaceModalCreateWorkspaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createWorkspaceModalCreateWorkspaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a481b6be5e8b9447de768ec304c3828",
    "id": null,
    "metadata": {},
    "name": "createWorkspaceModalCreateWorkspaceMutation",
    "operationKind": "mutation",
    "text": "mutation createWorkspaceModalCreateWorkspaceMutation(\n  $input: CreateWorkspaceInput!\n) {\n  createWorkspace(input: $input) {\n    workspace {\n      id\n      name\n      modified\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '51bff014ac7246001a3ebfdaeec4ce44';
export default node;
